import React from "react";

import SingleSelectDropdown from "../../widgets/Dropdown/SingleSelectDropdown";
import SearchCard from "../../widgets/SearchCard/SearchCard";
import VerticalRegistry from "../../constants/verticalRegistry";
import BranchSelector from "./components/BranchSelector/BranchSelector";
import useHomeForm from "./hooks/useHomeForm";
import { VERTICAL_NAMES, SEARCH_CARD_CONFIG } from "../../constants/constants";
import styles from "./Home.module.scss";

const HomeComponent = ({
  values,
  handleChange,
  handleSubmit,
  errors,
  touched,
  handleBlur,
  isSubmitting,
  setFieldValue,
  setValues,
  selectedBranch,
  setSelectedBranch,
  fetchSchoolBranches,
}) => {
  const { searchConfig, activeCard, handleVerticalChange, handleTabChange } =
    useHomeForm({ values, handleChange, setFieldValue }, setSelectedBranch);

  const isILSchools = values.vertical === VERTICAL_NAMES.IL_SCHOOLS;
  const verticalOptions = VerticalRegistry.getAllVerticals().map((v) => v.name);

  return (
    <div className={styles.homeWrapper}>
      <div className={styles.card}>
        <form onSubmit={handleSubmit}>
          <div className={styles.topFilters}>
            <SingleSelectDropdown
              label="Select Business Vertical"
              name="vertical"
              value={values.vertical}
              onChange={handleVerticalChange}
              options={verticalOptions}
            />

            {isILSchools && (
              <BranchSelector
                errors={errors}
                selectedBranch={selectedBranch}
                setSelectedBranch={setSelectedBranch}
                setValues={setValues}
                fetchSchoolBranches={fetchSchoolBranches}
              />
            )}
          </div>

          <SearchCard
            tabs={SEARCH_CARD_CONFIG}
            activeCard={activeCard}
            setActiveCard={handleTabChange}
            config={searchConfig}
            values={values}
            handleChange={handleChange}
            errors={errors}
            touched={touched}
            handleBlur={handleBlur}
            isLoading={isSubmitting}
          />
        </form>
      </div>
    </div>
  );
};

export default HomeComponent;
